import { createFormStoreEvents } from '../create-form-store-events';

export const bunkerEvents = createFormStoreEvents('bunkerStore');
